import { PERM } from '../auth/permissions'

// Menú por secciones. `icon` = nombre del set de íconos del diseño (ver components/Icon.jsx).
export const MENU = [
  {
    section: 'Ventas',
    items: [
      { label: 'Facturación Ágil', path: '/facturar', icon: 'zap', permission: PERM.FACTURACION_AGIL },
      { label: 'Comprobantes', path: '/documentos', icon: 'doc', permission: PERM.COMPROBANTE_INDEX },
      { label: 'Clientes', path: '/clientes', icon: 'users', permission: PERM.CLIENTE_INDEX },
      { label: 'Caja', path: '/caja', icon: 'pos' },
    ],
  },
  {
    section: 'Catálogos',
    items: [
      { label: 'Productos', path: '/productos', icon: 'box' },
      { label: 'Servicios', path: '/servicios', icon: 'tag' },
      { label: 'Depósitos', path: '/depositos', icon: 'inventory' },
      { label: 'Monedas', path: '/monedas', icon: 'dollar' },
      { label: 'Cotizaciones', path: '/cotizaciones', icon: 'exchange' },
      { label: 'Formas de pago', path: '/formas-pago', icon: 'cash' },
    ],
  },
]
